import React from "react";
import { Bell } from "lucide-react";

import { useLanguage } from "@/contexts/LanguageContext.jsx";
import { PageShell } from "./InstitutionsPage.jsx";

export default function InstitutionNotifications({ workspace, onInstitutionSelect }) {
  const { t } = useLanguage();
  return (
    <PageShell workspace={workspace} title={t("institutionNotifications.title", "Notifications")} icon={Bell} dashboardHeader onInstitutionSelect={onInstitutionSelect}>
      <main className="institution-home institution-notifications" aria-label={t("institutionNotifications.title", "Notifications")}>
        <h2 className="institution-home__title">{t("institutionNotifications.title", "Notifications")}</h2>
        <section className="institution-notifications__unavailable" role="status">
          <Bell size={28} aria-hidden="true" />
          <div>
            <h3>{t("institutionNotifications.unavailableTitle", "Institution notifications are not enabled yet")}</h3>
            <p>{t("institutionNotifications.unavailableBody", "This workspace does not query personal or cross-Institution notifications. Institution-scoped delivery will appear here once its governed recipient and authority contract is available.")}</p>
          </div>
        </section>
      </main>
    </PageShell>
  );
}
